// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3ivda","boxTitle":"Qualiphy_boxTitle__1AKko","box":"Qualiphy_box__1Abll","toggleWrap":"Qualiphy_toggleWrap__3AA8a"};